import { Box, FlexLayout } from '@deity/falcon-ui';
import EntityPicker from 'components/FlowEditor/components/panels/FlowComponentSettings/EntityPicker';
import { Collapsible } from 'components/PropertyListEditor/Collapsible';
import { SchemaActionTypes, SchemaContext } from 'contexts/SchemaContext';
import type { FC } from 'react';
import { useContext } from 'react';

interface EditFieldDefaultProps {
  locked: boolean;
  path: Array<string>;
  schema?: any;
}
const EditLinkFields: FC<EditFieldDefaultProps> = ({ locked, path, schema }) => {
  const ctx = useContext(SchemaContext);

  // const fieldProperties = schema.getProperties();

  return (
    <Box>
      <Collapsible
        collapsed={false}
        title="Link Settings"
        propertyBag={schema}
        // propertyList={fieldProperties}
        itemTitle="PROPERTIES"
      >
        <Box>
          <FlexLayout bg="panelLight" mt="xs" mb="xs" borderRadius="small" p="xs">
            <EntityPicker
              key="editLink"
              property="link"
              entityUUID={schema?.config?.link}
              entity="structure"
              // label="Select a Structure"
              name="Linked structure"
              // error={propertyErrors.length > 0}
              isEditable={!(locked || schema === undefined)}
              showEntityLink
              onChange={(key, val) => {
                ctx?.dispatch({
                  type: SchemaActionTypes.UPDATE_SETTING,
                  payload: { path, property: [key], value: val }
                });
              }}
            />
          </FlexLayout>
        </Box>
      </Collapsible>
    </Box>
  );
};

export default EditLinkFields;
